import { NavActions, NAVIGATION, NavState, REDIRECT_MAINTENANCE } from './types';

const initialState: NavState = {
  location: '',
  maintenance: false,
  previousLocation: '',
  query: {},
};

export const navReducer = (state = initialState, action: NavActions): NavState => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        previousLocation: state.location,
        location: action.context.canonicalPath.split('?')[0].replace(/\/$/, '').toLowerCase(),
        query: action.context.query,
      };

    case REDIRECT_MAINTENANCE:
      return {
        ...state,
        maintenance: action.enabled,
      };

    default:
      return state;
  }
};
